import { Pipe, PipeTransform } from '@angular/core';
import { PoPort } from 'src/app/models/data/po-relate.model';

@Pipe({
  name: 'queryPortName'
})
export class QueryPortNamePipe implements PipeTransform {

  transform(value: string, portList: PoPort[]): string {
    let result =''
    portList?.forEach(port => {
      if(port.port_code == value) result = port.port_name
    })
    return result
  }

}
